
import { Options, Vue } from 'vue-class-component';

@Options({})
export default class OptionHeader extends Vue {
  selectedVoice: Object = {};
  voicesList: any = null;
  async mounted() {
    this.getVoicesList().then(voices => {
      this.voicesList = voices;
    });
  }
  releaseSelected() {
    return this.selectedVoice;
  }

  async getVoicesList() {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        return resolve(window.speechSynthesis.getVoices());
      }, 150);
    });
  }
}
